import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';

import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { EMPLOYEE_PAY_EDIT, EMPLOYEE_PAY_LIST } from 'src/constants/EndpointUrls';
import { EMPLOYEE_PAY_FORM } from 'src/constants/FormNames';

import { setItem, getItem, mergeItemFields, getItemErrors } from 'src/reducers/common/itemReducer';
import { REDUCER_NAME, editEmployeePay, changeLock } from 'src/reducers/employees/employeePays';

import { setExtras } from 'src/reducers/common/listReducer';
import { REDUCER_NAME as MEMO_REDUCER_NAME } from 'src/reducers/memos/memos';
import { NextAndPrevRecordButton } from 'src/components';

import ConfirmationPayJobStatus from './components/ConfirmationPayJobStatus';
import DownloadPayCsvJobStatus from './components/DownloadPayCsvJobStatus';
import ImportPayCsvJobStatus from './components/ImportPayCsvJobStatus';
import EmployeePayFormContainer from './containers/EmployeePayFormContainer';
import styles from './EditEmployeePay.scss';

let EditEmployeePayForm = reduxForm({
  form: EMPLOYEE_PAY_FORM
})(EmployeePayFormContainer);

const mapStateToProps = state => ({
  initialValues: getItem(REDUCER_NAME, state),
  errors: getItemErrors(REDUCER_NAME, state)
});
const mapDispatchToProps = dispatch => ({
  onSubmit: data => {
    dispatch(editEmployeePay(data, data.employeePay.id));
  },
  handleLockItem: (employeePayId, currentConfirmed) => {
    dispatch(changeLock(employeePayId, currentConfirmed));
  }
});
EditEmployeePayForm = connect(mapStateToProps, mapDispatchToProps)(EditEmployeePayForm);

class EditEmployeePay extends React.Component {
  state = {
    isViewMode: true
  };

  componentWillMount() {
    const { dispatch, values } = this.props;
    dispatch(setItem(REDUCER_NAME, values));
    dispatch(
      mergeItemFields(REDUCER_NAME, {
        ...values,
        employeePay: { ...values.employeePay, customizeAllowances: values.customizeAllowances }
      })
    );
    dispatch(setExtras(MEMO_REDUCER_NAME, values.memos));
  }

  changeViewModeToTrue = () => {
    this.setState({ ...this.state, isViewMode: true });
  };

  changeViewModeToFalse = () => {
    this.setState({ ...this.state, isViewMode: false });
  };

  hashIsInputAllowanceItem = employeePay => ({
    isInputTotalWorkingDays: employeePay.isInputTotalWorkingDays,
    isInputPredeterminedWorkingDays: employeePay.isInputPredeterminedWorkingDays,
    isInputLegalHolidayWorkingDays: employeePay.isInputLegalHolidayWorkingDays,
    isInputAbsenceWorkingDays: employeePay.isInputAbsenceWorkingDays,
    isInputNumberPayDays: employeePay.isInputNumberPayDays,
    isInputNumberDayOffDays: employeePay.isInputNumberDayOffDays,
    isInputPredeterminedWorkingTime: employeePay.isInputPredeterminedWorkingTime,
    isInputTotalWorkingTime: employeePay.isInputTotalWorkingTime,
    isInputActualOvertimeTime: employeePay.isInputActualOvertimeTime,
    isInputOvertimeNightTime: employeePay.isInputOvertimeNightTime,
    isInputOvertimeLawTime: employeePay.isInputOvertimeLawTime,
    isInputLateSoonTime: employeePay.isInputLateSoonTime,
    isInputLegalStandingOvertimeTime: employeePay.isInputLegalStandingOvertimeTime,
    isInputOvertimeOver60HoursTime: employeePay.isInputOvertimeOver60HoursTime,
    isInputWorkedHolidayDays: employeePay.isInputWorkedHolidayDays,
    isInputWorkedHolidayTime: employeePay.isInputWorkedHolidayTime,
    isInputPredeterminedWorkingHolidayDays: employeePay.isInputPredeterminedWorkingHolidayDays,
    isInputPredeterminedWorkingHolidayTime: employeePay.isInputPredeterminedWorkingHolidayTime,
    isInputNumberLateSoonTimes: employeePay.isInputNumberLateSoonTimes,
    isInputOvertimeOver45HoursTime: employeePay.isInputOvertimeOver45HoursTime,
    isInputPayTime: employeePay.isInputPayTime,
    isInputPrescribedWorkingTime: employeePay.isInputPrescribedWorkingTime,
    isInputOvertimeWorkingTime: employeePay.isInputOvertimeWorkingTime
  });

  get isViewMode() {
    return this.state.isViewMode;
  }

  render() {
    const { id, employeeId } = this.props.values.employeePay;

    const { nextInfo, prevInfo, paymentMonthConfirmed, allowanceItems, allEmployeePays, motivationStreaks } = this.props.values;

    return (
      <div className="l-wrap-xl l-contents-wrap">
        <div className={styles.head}>
          <BreadCrumb>
            <BreadCrumb.Item label={this.props.t('features.EmployeePays.EmployeePayList.salary_list')} path={EMPLOYEE_PAY_LIST} />
            <BreadCrumb.Item label={this.props.t('features.EmployeePays.EditEmployeePay.salary_detail')} />
          </BreadCrumb>
          <NextAndPrevRecordButton {...{ nextInfo, prevInfo, urlFormat: EMPLOYEE_PAY_EDIT }} />
        </div>

        {!paymentMonthConfirmed && (
          <div className={styles.hide}>
            {/* Trigger for checking having running job or not to disable/enable edit button */}
            <ConfirmationPayJobStatus />
            <DownloadPayCsvJobStatus />
            <ImportPayCsvJobStatus />
          </div>
        )}

        <EditEmployeePayForm
          employeeId={employeeId}
          employeePayId={id}
          changeViewModeToTrue={this.changeViewModeToTrue}
          changeViewModeToFalse={this.changeViewModeToFalse}
          isViewOnly={this.isViewMode}
          paymentMonthConfirmed={paymentMonthConfirmed}
          allowanceItems={allowanceItems}
          isInputAllowanceItems={this.hashIsInputAllowanceItem(this.props.values.employeePay)}
          allEmployeePays={allEmployeePays}
          motivationStreaks={motivationStreaks}
        />
      </div>
    );
  }
}

export default withTranslation()(connect()(EditEmployeePay));
